import { GzContentControlWebDataProtectionExclusionsFormWebComponent } from './component/GzContentControlWebDataProtectionExclusionsFormWebComponent';

export { GzContentControlWebDataProtectionExclusionsFormWebComponent };
